import { theme } from '@chakra-ui/react'

export const shadows = {
  ...theme.shadows,
  container: '0px 2px 2px rgba(0,0,0,0.15)',
}
